<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Theatre
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>In 2025, <strong>Theatre</strong> generated $101.4m in revenue and attracted close to 1.3m attendances.</p>
          <p><strong>Theatre</strong> recorded a y-o-y decline in revenue of 3.8% (from $105.4m in 2024 to $101.4m in 2025) and a y-o-y decline in attendance of 9.1% (from 1.4m in 2024 to 1.3m in 2025). The average ticket price increased by 5.2% y-o-y (from $83.86 in 2024 to $88.23 in 2025) to offset rising production and touring costs and partially offset the decline in revenue.</p>
          <p>In 2025, <strong>Theatre</strong> revenue and attendance continued to remain lower than their peaks in 2019 when <em>Harry Potter and the Cursed Child</em> commenced its long running season.</p>
          <p>Revenue in this category was primarily driven by events such as <em>And Then There Were None</em>, <em>The Play That Goes Wrong</em>, <em>A Christmas Carol</em>, <em>The Talented Mr. Ripley</em>, <em>RBG: Of Many, One</em>, <em>Rebecca</em>, <em>Critical Role Live</em>, <em>Julia</em>, and <em>The 39 Steps</em>.</p>
          <p><strong>Theatre</strong> accounted for 3.0% of the overall live performance revenue and 4.1% of the total attendance in 2025.</p>
          <p>50.0% of the revenue and 54.0% of the attendance in 2025 were generated through performances by NPAP companies such as Sydney Theatre Company, Melbourne Theatre Company, Belvoir, Bell Shakespeare, Black Swan State Theatre Company, Queensland Theatre and State Theatre Company South Australia. In recent years, <strong>Theatre</strong> has seen an increase in the number of commercial productions in market, shifting the market share generated by NPAP companies.</p>
        </div>
        <div class="sixcol last">
          <p>NSW generated the highest revenue and attendance in this category, with a national market share of approximately 36.4% in revenue and 37.7% in attendance in 2025. Top events in NSW included <em>The Play That Goes Wrong</em>, <em>And Then There Were None</em>, <em>The Talented Mr. Ripley</em> and <em>RBG: Of Many, One</em>.</p>
          <p>VIC generated the second-highest revenue and attendance in this category, with a national market share of approximately 34.5% in revenue and 31.8% in attendance. Top events in VIC included <em>And Then There Were None</em>, <em>A Christmas Carol</em>, <em>Rebecca</em>, <em>Critical Role Live</em> and <em>Julia</em>.</p>
          <p>Combined VIC and NSW generated 70.9% of overall revenue and 69.5% of attendance in this category in 2025.</p>
          <p>All states and territories except QLD, WA and SA recorded a y-o-y decline in revenue and attendance in 2025.</p>
          <p>QLD recorded the highest y-o-y growth in revenue (115.9%) and attendance (83.3%) and SA recorded the second-highest y-o-y growth in revenue (47.7%) and attendance (29.5%) in 2025.</p>
          <p>Top events in QLD included <em>The Dictionary of Lost Words</em>, <em>The 39 Steps</em> and <em>Julia</em>. Top events in SA included <em>And Then There Were None</em> and <em>The Dictionary of Lost Words</em>.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/THEATRE  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Theatre Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Dear Son</em>, Queensland Theatre Company and State Theatre Company South Australia, Photo Credit: David Kelly</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y.toFixed(3) + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [89.418, 73.989, 143.564, 117.383, 80.477, 64.441, 60.151, 65.881, 82.973, 119.647, 99.715, 56.832, 79.584, 64.218, 78.505, 146.562, 39.867, 53.563, 111.362, 121.774, 105.446, 101.387],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [2.203, 2.118, 3.828, 2.505, 1.944, 1.603, 1.354, 1.381, 1.601, 1.842, 1.504, 1.135, 1.352, 1.458, 1.43, 1.531, 0.422, 0.662, 1.364, 1.438, 1.386, 1.260],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 36.4],
            ["VIC", 34.5],
            ["QLD", 14.1],
            ["WA", 7.3],
            ["SA", 4.4],
            ["ACT", 3.0],
            ["TAS", 0.3],
            ["NT", 0.1],
          ],
          attendance: [
            ["NSW", 37.7],
            ["VIC", 31.8],
            ["QLD", 14.5],
            ["WA", 7.8],
            ["SA", 4.7],
            ["ACT", 3.0],
            ["TAS", 0.5],
            ["NT", 0.1],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/29-Theatre-The-company-of-Dear-Son,-Queensland-Theatre-Company-and-State-Theatre-Company-South-Australia.-Photo-credit-David-Kelly-(2).jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
